import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/header';
import Footer from '@/components/footer';
import Sidebar from '@/components/sidebar';
import MobileNavDrawer from '@/components/mobile-nav-drawer';
import { MapProvider } from '@/components/map/map-context';
import MapTools from '@/components/map-tools';
import { MenuProvider } from '@/hooks/use-menu.tsx';
import { useViewportHeight } from '@/hooks/use-viewport-height';
import { SidebarProvider, useSidebar } from '@/hooks/use-sidebar.tsx';

function LayoutContent() {
  const { isOpen } = useSidebar();
  const handleClose = () => {};

  return (
    <MapProvider>
      <Header />
      <MobileNavDrawer />
      <Flex w='full' h='calc((var(--vh, 1vh) * 100) - 84px)' position='relative'>
        <Box 
          display={{ base: 'none', lg: 'block' }}
          w={{ base: 'full', lg: isOpen ? '20rem' : '0' }}
          overflow='hidden'
          transition='width 0.3s ease-in-out'
        >
          <Sidebar onClose={handleClose} />
        </Box>
        <Box flex='1' h='full' overflow='hidden' position='relative'>
          <Outlet />
        </Box>
        <MapTools />
      </Flex>
      <Footer />
    </MapProvider>
  );
}

export default function Layout() {
  useViewportHeight();
  
  return (
    <MenuProvider>
      <SidebarProvider>
        <LayoutContent />
      </SidebarProvider>
    </MenuProvider>
  );
}
